import './instrument'; // MUST be first: initialises Sentry before anything else
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Front/assets/css/main.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {applyWhiteLabelTheme} from "./Front/config/whiteLabelThemes";
import Sentry from "./Front/config/sentry";
import ReactGA from "react-ga4";

ReactGA.initialize("G-6RDXSQNTG5");

applyWhiteLabelTheme();

// React 19 error hooks: report render errors to Sentry (no-op without a DSN).
// Overriding the hooks disables React's own console output, so keep logging here.
const logReactError = (error, errorInfo) => {
  console.error(error, errorInfo?.componentStack);
};

const root = ReactDOM.createRoot(document.getElementById('root'), {
  onUncaughtError: Sentry.reactErrorHandler(logReactError),
  onCaughtError: Sentry.reactErrorHandler(logReactError),
  onRecoverableError: Sentry.reactErrorHandler(logReactError),
});
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
